import { testimonials } from "@/mocks/guagua";

const stats = [
  { num: "12,800+", label: "每日在线围观" },
  { num: "200+", label: "覆盖高校" },
  { num: "68,000+", label: "精选吃瓜段子" },
  { num: "9.5 分", label: "围观快乐指数" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 to-primary-700 text-background-50">
          <div className="grid gap-8 p-8 md:p-12 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs md:text-sm">
                <span>🍉</span> 校园吃瓜 · 轻松校园生活社区
              </p>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-snug">
                课后的快乐，都藏在这些瓜里
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-background-50/90">
                我们相信，校园生活不止有上课和考试，还有无数让人会心一笑的瞬间。
                校园吃瓜把这些散落在各栋教学楼、食堂和宿舍里的趣事聚到一起，
                让你忙碌的课业之余也能松口气，和天南地北的同学一起乐呵乐呵。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="#feed" className="rounded-full bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 hover:bg-background-200 transition-colors whitespace-nowrap">
                  去围观趣事
                </a>
                <a href="#submit" className="rounded-full border border-background-50/50 px-5 py-2.5 text-sm text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap">
                  分享我的故事
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-background-50/10 p-5 text-center">
                  <p className="font-heading text-xl md:text-2xl text-background-50">{s.num}</p>
                  <p className="mt-1 text-xs md:text-sm text-background-50/80">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          <div className="flex items-start gap-3 rounded-2xl bg-background-50 border border-background-200 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-600 text-xl"><i className="ri-heart-3-line"></i></span>
            <div>
              <h3 className="font-heading text-base text-foreground-950">轻松友善的围观氛围</h3>
              <p className="mt-1.5 text-sm text-foreground-700">倡导善意吃瓜，不开玩笑不越界，让每个人都能放心分享、放心围观。</p>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-2xl bg-background-50 border border-background-200 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 text-xl"><i className="ri-user-heart-line"></i></span>
            <div>
              <h3 className="font-heading text-base text-foreground-950">天南海北找到同好</h3>
              <p className="mt-1.5 text-sm text-foreground-700">评论区里藏着无数"原来你也这样"的惊喜，吃瓜也能吃出好朋友。</p>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-2xl bg-background-50 border border-background-200 p-5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700 text-xl"><i className="ri-chat-smile-2-line"></i></span>
            <div>
              <h3 className="font-heading text-base text-foreground-950">贴近真实校园生活</h3>
              <p className="mt-1.5 text-sm text-foreground-700">每一段趣事都来自同学分享的真实日常，接地气才有共鸣才有乐。</p>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <h3 className="font-heading text-xl md:text-2xl text-foreground-950 text-center">同学都怎么说</h3>
          <div className="mt-6 grid gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl bg-background-50 border border-background-200 p-5">
                <div className="flex text-secondary-500" aria-label="5星好评">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700 font-heading">
                    {t.name[0]}
                  </span>
                  <span className="text-sm font-medium text-foreground-950">{t.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}